import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import DoneIcon from '@material-ui/icons/Done';
import ClearIcon from '@material-ui/icons/Clear';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import classes from './AccordEntry.module.css';
import { useAuth } from '../../contexts/AuthContext';
import { Editor } from '@tinymce/tinymce-react';
import parse from 'html-react-parser';
import Chevron from '../Chevron';

const AccordionEntry = (props) => {
  const [editMode, setEditMode] = useState(false);
  const [deleteMode, setDeleteMode] = useState(false);
  const { currentUser, idToken } = useAuth();

  const [active, setActive] = useState(false);
  const [height, setHeight] = useState(0);

  const [rotate, setRotate] = useState('accordion__icon');

  const content = useRef(null);

  function confirmHandler(event, title = 'title', info = 'info') {
    console.log(event)
    event.stopPropagation()
    const information = { title: title, info: info };
    console.log(
      `https://accordion-production-default-rtdb.firebaseio.com/users/${currentUser.uid}/${props.fileName}/${props.fileId}.json`
      );
      axios
      .patch(
        `https://accordion-production-default-rtdb.firebaseio.com/users/${currentUser.uid}/${props.fileName}/${props.fileId}.json?auth=${idToken}`,
        information
        )
        .then((response) => console.log(response))
        .catch((error) => {
          alert(
            'information failed to get sent to server. copy and paste info somewhere safe, then hit edit, and confirm once more'
            );
            console.log(error);
          });
          setEditMode(false);
          setActive(true)

  }

  function handleEditorChange(content, editor) {
    console.log('Content was updated:', content);
    props.infoHandler(props.index, content);
  }


  let finalTitle = props.title;
  let info = parse(props.info);
  if (editMode === true) {
    finalTitle = <input onChange={props.titleHandler} value={props.title} />;
    info = (
      <Editor
        value={props.info}
        init={{
          height: height, 
          menubar: false,
          // inline: true,
          plugins: [
            'advlist autolink lists link image charmap print preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table paste code help wordcount',
            'nonbreaking',
          ],
          nonbreaking_force_tab: true,
          fontsize_formats:
            '8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt',
          toolbar:
            'undo redo | fontsizeselect | bold italic underline strikethrough | backcolor forecolor fontselect | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist outdent indent | removeformat | help',
            // valid_elements: '"@[id|class|style|title"],h1,h2,h3,h4,h5,h6,p,hr, ul, ol, li, br [size|noshade]'
            selector: 'div',
            toolbar_sticky : true,
            toolbar_sticky_offset: 87
        }}
        onEditorChange={handleEditorChange}
      />
    );
  }

  function cancelHandler(event) {
    event.stopPropagation()

    setEditMode(false)
    setActive(false)
    setHeight(0)
    setDeleteMode(!deleteMode);
  }
  function deleteHandler(event) {
    event.stopPropagation()
    setActive(true)
    setHeight(content.current.scrollHeight + 200)
    setDeleteMode(!deleteMode);
  }
  let deleteChoice = (
    <IconButton aria-label="delete" onClick={deleteHandler}>
      <DeleteForeverIcon />
    </IconButton>
  );
  if (deleteMode === true) {
    deleteChoice = (
      <>
        <IconButton
          aria-label="confirm"
          onClick={() => {
            props.remove(props.fileId);
            setDeleteMode(!deleteMode);
          }}
        >
          <DoneIcon />
        </IconButton>

        <IconButton aria-label="cancel" onClick={cancelHandler}>
          <ClearIcon />
        </IconButton>
      </>
    );
  }
  function toggleAccordion() {


    if(editMode) setActive(true)
    else {


      if(active){

        setHeight(0)
        setActive(false)
      }
      else{
        setHeight(content.current.scrollHeight + 200)
        setActive(true)
      }

  }
}
  function editHandler(event) {
    event.stopPropagation()
    setHeight(content.current.scrollHeight + 200)
    setEditMode(true);
    setActive(true)

  }
  let editChoice = (
    <IconButton aria-label="edit" onClick={editHandler}>
      <EditIcon />
    </IconButton>
  );
  if (editMode === true) {
    editChoice = (
      <IconButton
        aria-label="confirm"
        onClick={(event) => confirmHandler(event, props.title, props.info)}
      >
        <DoneIcon />
      </IconButton>
    );
  }

  useEffect(() => {
    if(active || editMode) setRotate( `${classes['accordion__icon']} ${classes['rotate']}`)
    else{

      setRotate(classes['accordion__icon'])
      console.log('rotate fired')
    } 

  }, [active, editMode, height]);


  return (
    <div className={classes['accordion']}>
      <div
        className={active || editMode ? `${classes['accordion__header']} ${classes['active']}` : `${classes['accordion__header']} `}
        onClick={toggleAccordion}
      >
        <Chevron className={`${rotate}`} width={10} fill={'white'} />
        <div className={classes['accordion__header__edit']}>{editChoice} </div>
        <p className={classes['accordion__header__text']}>{finalTitle}</p>
        <div className={classes['accordion__header__delete']}>
          {deleteChoice}
        </div>
      </div>

      <div
        ref={content}
        id={`${props.id}`}
        style={{ maxHeight: `${height}px` }}
        className={classes['accordion__content']}
      >
        {info}
      </div>
    </div>
  );
};

export default AccordionEntry;
